export default {
  userInfo: state => state.userInfo || {},
  permissions: state => state.permissions || []
}
